import { render } from "./CascadeSelect.vue?vue&type=template&id=0979bf03&scoped=true"
import script from "./CascadeSelect.vue?vue&type=script&lang=js"
export * from "./CascadeSelect.vue?vue&type=script&lang=js"

import "./CascadeSelect.vue?vue&type=style&index=0&id=0979bf03&scoped=true&lang=css"

import exportComponent from "D:\\Programs\\Vue\\frame2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0979bf03"]])

export default __exports__
import QSelect from 'quasar/src/components/select/QSelect.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import QTree from 'quasar/src/components/tree/QTree.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSelect,QChip,QTree,QCheckbox,QIcon});
